import { useMemo } from 'react'

import { TCartItem, useCart } from '@/entities/cart'

import { ProductType } from '@/shared/types/deprecated-types'

export type UseAppliedServicesReturn = {
	appliedServices: TCartItem[]
	activeServiceTitles: string[]
	hasAppliedServices: boolean
}

/**
 * Хук для получения примененных услуг к конкретному товару в корзине
 * @param productId - ID товара в корзине
 * @returns объект с массивом примененных услуг, их названиями и флагом наличия
 */
export const useAppliedServices = (productId: number): UseAppliedServicesReturn => {
	const { products } = useCart()

	const appliedServices = useMemo(() => {
		if (!products?.length) return []

		return products.filter(item => item.TYPE_PRODUCTS === ProductType.Service && item.RELATED_PRODUCTS === productId)
	}, [products, productId])

	const activeServiceTitles = useMemo(() => {
		return appliedServices.map(service => service.TITLE)
	}, [appliedServices])

	return {
		appliedServices,
		activeServiceTitles,
		hasAppliedServices: appliedServices.length > 0
	}
}
